import React, { useContext, useEffect, useRef, useState } from 'react';
import coreStyle from "sass-boilerplate/stylesheets/style.module.scss";
import EcardPage from '../../EcardPage';
import postTabStyle from 'sass-boilerplate/stylesheets/components/wall/PostTabs.module.scss';
import pointsStyle from 'sass-boilerplate/stylesheets/components/launch/Points.module.scss';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TextInput from 'components/atoms/ui/TextInput';
import eCardStyle from 'sass-boilerplate/stylesheets/components/launch/Ecard.module.scss';
import inputStyle from 'assets/style/common/Input.module.scss';
import { BUTTON_MAIN_TYPE } from 'constants/ui';
import buttonStyle from 'assets/style/common/Button.module.scss';
import Button from 'components/atoms/ui/Button';
import { useIntl } from 'react-intl';
import { DynamicFormattedMessage } from 'components/atoms/ui/DynamicFormattedMessage';
import BdcDemandApi from 'api/BdcDemandApi';
import { UserContext } from 'components/App';
import { useWallSelection } from 'hooks/wall/useWallSelection';
import { BdcDemandModelApi, companyModelApi, setBdcDemandModelApi, BDC_DEMAND_STATUS } from './BdcDemandModel';
import { PENDING } from 'constants/wall/users';
import FlexibleModalContainer from 'containers/FlexibleModalContainer';
import style from 'sass-boilerplate/stylesheets/components/wall/PostMedia.module.scss';
import styles from 'assets/style/components/BDC/BdcWinsDemandModal.module.scss'
import request, { AxiosError } from "axios";
import axios from 'axios';
import { components } from 'react-select';
import SearchableFilterSelect from 'components/atoms/ui/SearchableFilterSelect';

const { withBoldFont, displayFlex, mt2, mb2, textLeft, mt1, bfVisibilityHidden } = coreStyle;


const { pt3, pb3 } = coreStyle;

type BdcTarget = {
  companyId: number;
  companyName: string;
  superAdminFirstName: string;
  superAdminLastName: string;
  superAdminEmail: string;
  superPlatforms: Array<{ id: number; name: string }>;
  erpReady: boolean;
  walletWins: number;
};

const BdcWinsDemand = ({onRewardsRedirectClick, onCreated = null, hyperAdminMode = false, preferCompanyRoot = false}) => {

  const [isActualWinsSetted, setIsActualWinsSetted] = useState<boolean>(false);
  const [etsActualAccount, setEtsActualAccount] = useState<number>();
  const [etsActualAccountWins, setEtsActualAccountWins] = useState<number>();
  
  
  const [bdCDemandAmount, setBdcDemandAmount] = useState<number>();
  const [bdcDemandAmountTxt, setBdcDemandAmountTxt] = useState<string>();
  const [bdcDemandAmountWins, setBdcDemandAmountWins] = useState<number>();
  const [companyWins, setCompanyWins] = useState<companyModelApi>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProviderModalOpen, setIsProviderModalOpen] = useState(false);
  const [isOK, setIsOk] = useState(false);
  const [isLimit, setIsLimit] = useState(false);
  const [isSameAmount, setIsSameAmount] = useState(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [bdcProvider, setBdcProvider] = useState<'loading' | 'error' | 'cynov' | 'internal'>('loading');
  const [selectedProvider, setSelectedProvider] = useState<'cynov' | 'internal'>('internal');
  const [ownErpReady, setOwnErpReady] = useState<boolean | null>(null);
  const [internalReady, setInternalReady] = useState(false);
  const [targets, setTargets] = useState<BdcTarget[]>([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState<number>();
  const [targetsError, setTargetsError] = useState(false);
  const [isWarning, setIsWarning] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const {
    inputBlock,
    customTextInputBcd,
    marginTop0,
    cardTemplate,
    cardTemplateConvert,
    bdcDemand,
    bdcDemandInput
  } = eCardStyle;

  const { formatMessage } = useIntl();
  const { userData } = useContext(UserContext);
  const { selectedProgramId, selectedPlatform: { id: platformId } } = useWallSelection();
  const selectedTarget = targets.find(target => target.companyId === selectedCompanyId);

  const getActualWinsCompany = async ()=>{
    try {
      const bdcDemandApi = new BdcDemandApi();
      const userUuid = userData.uuid;
      const data: BdcDemandModelApi = await bdcDemandApi.getWinsCompany(selectedProgramId, userUuid);
      
      
      console.log("HADA DATA: " + {data})
      setEtsActualAccountWins(data.data.wallletCompany.wins);  
      setCompanyWins(data.data.company); 
      setIsActualWinsSetted(true);
      // const data1: BdcDemandModelApi = await bdcDemandApi.getBdcDemandHistory();
      // console.log(data1);
      } catch (error) {
      setIsActualWinsSetted(false);
      
      console.error('ERRORS Occured wile requestting getWinsCompany Api !')
    }
  }

  const getEtsActualAccount = () => {
    
    // if (etsActualAccount && etsActualAccount > 0) {
    //   const wins = etsActualAccount / 0.04;
    //   setEtsActualAccountWins(wins);
    // }
  }

  useEffect(() => {
    if (hyperAdminMode) {
      new BdcDemandApi().getBdcCompanies()
        .then(response => setTargets(response.data))
        .catch(() => setTargetsError(true));
    } else {
      getActualWinsCompany();
    }
    new BdcDemandApi().getBdcConfig()
      .then(response => {
        setBdcProvider(response.data.provider);
        setOwnErpReady(response.data.erpReady);
        setInternalReady(response.data.internalReady);
      })
      .catch(() => setBdcProvider('error'));
    // getEtsActualAccount();
  }, [hyperAdminMode])

  const selectTarget = (companyId: number) => {
    const target = targets.find(item => item.companyId === companyId);
    setSelectedCompanyId(companyId || undefined);
    setEtsActualAccountWins(target ? target.walletWins : 0);
    setIsActualWinsSetted(!!target);
  };

  
  const sendBdcDemand = async(isUserAcceptDuplicatedAmounts: boolean, provider: 'cynov' | 'internal' = hyperAdminMode ? selectedProvider : bdcProvider as 'cynov' | 'internal') =>{
    if (submittingRef.current) return;
    setIsOk(false);
    setIsLimit(false);
    setIsSameAmount(false);
    if (isActualWinsSetted && (!hyperAdminMode || selectedTarget) && bdcProvider !== 'loading' && bdcProvider !== 'error'
      && (provider !== 'internal' || internalReady)
      && (provider !== 'cynov' || (hyperAdminMode ? selectedTarget?.erpReady : ownErpReady))
      && bdCDemandAmount && parseFloat(bdCDemandAmount?.toString()) > 0) {
      const bdcDemandApi = new BdcDemandApi();
      const userUuid = userData.uuid;
      let body : setBdcDemandModelApi = {
        platformId: hyperAdminMode || preferCompanyRoot ? undefined : platformId,
        userAdminUuId:userUuid,
        companyId: hyperAdminMode ? selectedTarget.companyId : undefined,
        provider: hyperAdminMode ? provider : undefined,
        bdcId: '', 
        bdcDateExp:'',
        invoiceId:'',
        invoiceDate:'',
        amount: parseFloat(bdCDemandAmount?.toString()||'') ,
        wins: bdcDemandAmountWins,
        companyIban: hyperAdminMode ? '' : companyWins.iban,
        companyBic: hyperAdminMode ? '' : companyWins.bic,
        companySiretSiren: hyperAdminMode ? '' : companyWins.siretSiren,
        status: BDC_DEMAND_STATUS.PENDING,
        comment: "",
        errorCode: null,
        errorMsg: null,
        isUserAcceptDuplicatedAmounts : isUserAcceptDuplicatedAmounts,
        isBdcSending: true

      }
      submittingRef.current = true;
      setIsSubmitting(true);
      try {
        const data = await bdcDemandApi.setBdcDemandHisory(body);
        if (onCreated) onCreated();
        setModalMessage(provider === 'internal' ? 'bdc.modal.internal.ok' : 'bdc.modal.ok');
        setIsOk(true);
        setIsLimit(false);
        setIsSameAmount(false);
        // closeModal(isOk, isSameAmount, isLimit );
        // setIsModalOpen(true);
        showModal(true, false, false, provider);
      }  catch(err) {
        // body.errorCode = error.code;
        // body.errorMsg = error.message;
        // const data = await bdcDemandApi.updateBdcDemanHistory(body);
        const errors = err as AxiosError;
        // if(!axios.isAxiosError(error)){
        //   // do whatever you want with native error
        // }
        console.log(errors?.response)
        console.error('ERRORS Occured wile requestting getWinsCompany Api !');
        setIsOk(false);
        const isLimit  = errors?.response.data?.field == "USER LIMIT";
        const isSameAmount  = errors?.response.data?.field == "SAME AMOUNT";
        // const errorMsg =  errors?.response.data.message ? errors?.response.data.message : "Erreurs lors de l'envoi du bon de commande";
        setIsLimit(isLimit);
        setIsSameAmount(isSameAmount );
        setModalMessage("bdc.modal.error");
        showModal(false, isSameAmount, isLimit);
      } finally {
        submittingRef.current = false;
        setIsSubmitting(false);
      }
      
    } else {
      alert('Erreurs lors de la récupération des wins, veuillez contacter le support Yoowin')
    }
  }

  const currencyFormatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2

  });

  const nbrFormatter = new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: 0
  });

  const setBdcDemandAmountFn = (value) => {
    if (value) {
      if (value.indexOf('€') > 0 || value.indexOf(',') > 0) {
        value = parseFloat(value.replaceAll('€', '').replaceAll(',','.').replace(/[^\d.]/g, ""));        
      }
      setBdcDemandAmount(value);
      const cents = Math.round(value * 100);
      const wins = Math.floor(cents / 4) + (cents % 4 > 2 ? 1 : 0);
      setBdcDemandAmountWins(wins);
      setBdcDemandAmountTxt(value);
    }
  }

  const onMouseOut = (value)=>{
    setBdcDemandAmountTxt(currencyFormatter.format(value));
  }
  const onMouseIn = (value)=>{
    if (value.indexOf('€') > 0 || value.indexOf(',') > 0) {
      value = parseFloat(value.replaceAll('€', '').replaceAll(',','.').replace(/[^\d.]/g, ""));        
    }
    setBdcDemandAmountTxt(value);
  }

  const onClickOk = ()=>{
    setIsModalOpen(false)
  }

  const onClickOkWarning = ()=>{
    setIsModalOpen(false)
    sendBdcDemand(true)
  }

  const closeAndReturn = () => {
    setIsModalOpen(false);
    if (onRewardsRedirectClick) onRewardsRedirectClick();
  };

  const showModal = (isOk, isSameAmount, isLimit, selectedProvider: 'cynov' | 'internal' = bdcProvider as 'cynov' | 'internal')=>{
    if(isOk){
      setModalMessage(selectedProvider === 'internal' ? 'bdc.modal.internal.ok' : 'bdc.modal.ok')
      setIsWarning(false)
      setIsModalOpen(true)
    }else{
      if(isLimit){
        setModalMessage("bdc.limitError.modal")
        setIsWarning(false)
        setIsModalOpen(true)
      } else if(isSameAmount){
        setModalMessage("bdc.sameAmountError.modal")
        setIsWarning(true)
        setIsModalOpen(true)
      } else {
        setModalMessage('bdc.default.error');
        setIsWarning(false)
        setIsModalOpen(true)
      }
    }
  }



  const canConfirmProvider = selectedProvider === 'internal' ? internalReady : !!selectedTarget?.erpReady;

  return (
    <div className={`${bdcDemand} ${hyperAdminMode ? styles.hyperDemand : ''}`}>
      {hyperAdminMode && (
        <section className={styles.targetSection} aria-labelledby="bdc-target-label">
          <div className={styles.targetField}>
            <label id="bdc-target-label" htmlFor="bdc-target">{formatMessage({ id: 'bdc.target' })}</label>
            <SearchableFilterSelect id="bdc-target"
              options={targets.map(target => ({ value: target.companyId, label: target.companyName }))}
              selectedValues={selectedTarget ? [{ value: selectedTarget.companyId, label: selectedTarget.companyName }] : []}
              onChange={values => selectTarget(Number(values[0].value))}
              placeholder={formatMessage({ id: 'bdc.target.select' })} />
          </div>
          {targetsError && <p className={styles.targetError} role="alert">{formatMessage({ id: 'bdc.target.error' })}</p>}
          {selectedTarget && <dl className={styles.targetDetails}>
            <div>
              <dt>{formatMessage({ id: 'bdc.target.superAdmin' })}</dt>
              <dd>{selectedTarget.superAdminFirstName} {selectedTarget.superAdminLastName}
                <span className={styles.targetEmail}>{selectedTarget.superAdminEmail}</span>
              </dd>
            </div>
            <div>
              <dt>{formatMessage({ id: 'bdc.target.platform' })}</dt>
              <dd>{selectedTarget.superPlatforms.map(platform => platform.name).join(', ')}</dd>
            </div>
          </dl>}
        </section>
      )}
      {!hyperAdminMode && <div style={{ marginBottom: '2rem' }}>
        {bdcProvider === 'cynov' && ownErpReady === false &&
          <span role="alert">{formatMessage({ id: 'bdc.target.erpUnavailable' })}</span>}
        {bdcProvider === 'internal' && !internalReady &&
          <span role="alert">{formatMessage({ id: 'bdc.config.internalUnavailable' })}</span>}
      </div>}
      <div className={`${inputBlock} ${bdcDemandInput}`}>
        {/* <TextInput
          value={currencyFormatter.format(etsActualAccount)}
          disabled={true}
          onChange={({ target }) => null}
          wrapperClass={`${inputStyle.container} ${inputStyle.floating} ${customTextInputBcd}`}
          hasLabel={true}
          labelId="bdcDemand.etsActualAccount"
        /> */}
        <TextInput
          value={nbrFormatter.format(etsActualAccountWins || 0)}
          disabled={true}
          onChange={({ target }) => null}
          wrapperClass={`${inputStyle.container} ${inputStyle.floating} ${customTextInputBcd}`}
          hasLabel={true}
          labelId={hyperAdminMode ? 'bdc.target.walletWins' : 'bdcDemand.etsActualAccountWins'}
        />
        <DynamicFormattedMessage
          tag="span"
          className={`${coreStyle.mxAuto}`}
          id="bdcDemand.bdcDemandQuestion"
        />
        <TextInput
          value={bdcDemandAmountTxt}
          disabled={false}
          onChange={({ target }) => setBdcDemandAmountFn(target.value)}
          wrapperClass={`${inputStyle.container} ${inputStyle.floating} ${customTextInputBcd}`}
          hasLabel={true}
          labelId="bdcDemand.bdcDemandAmount"
          onBlur = {({ target }) => onMouseOut(target.value)}
          onFocus = {({ target }) => onMouseIn(target.value)}
        />
        <TextInput
          value={nbrFormatter.format(bdcDemandAmountWins || 0)}
          disabled={true}
          onChange={({ target }) => null}
          wrapperClass={`${inputStyle.container} ${inputStyle.floating} ${customTextInputBcd}`}
          hasLabel={true}
          labelId="bdcDemand.bdcDemandAmountWins"
        />
      </div>

      {bdcProvider === 'error' && (
        <span role="alert">{formatMessage({ id: 'bdc.config.error' })}</span>
      )}

      <Button
        onClick={() => {
          if (hyperAdminMode) {
            setSelectedProvider('internal');
            setIsProviderModalOpen(true);
          } else {
            sendBdcDemand(false);
          }
        }}
        type={BUTTON_MAIN_TYPE.SECONDARY}
        loading={isSubmitting}
        disabled={isSubmitting || isProviderModalOpen || isModalOpen
          || bdcProvider === 'loading' || bdcProvider === 'error' || !isActualWinsSetted
          || (hyperAdminMode && !selectedTarget)
          || (hyperAdminMode ? (!selectedTarget?.erpReady && !internalReady)
            : (bdcProvider === 'cynov' && !ownErpReady) || (bdcProvider === 'internal' && !internalReady))
          || !(bdCDemandAmount && parseFloat(bdCDemandAmount?.toString()) > 0)}
        className={`${marginTop0}`}
      >
        {formatMessage({ id: 'btn.label.sendBdcDemand' })}
      </Button>

      {hyperAdminMode && <FlexibleModalContainer
        className={styles.providerModal}
        fullOnMobile={false}
        closeModal={() => setIsProviderModalOpen(false)}
        isModalOpen={isProviderModalOpen}
      >
        <div className={styles.providerContent}>
          <h2 className={styles.providerTitle}>{formatMessage({ id: 'btn.label.sendBdcDemand' })}</h2>
          <div className={styles.providerField}>
            <label htmlFor="bdc-provider">{formatMessage({ id: 'bdc.provider' })}</label>
            <SearchableFilterSelect id="bdc-provider"
              options={[
                { value: 'internal', label: formatMessage({ id: 'bdc.provider.internal' }) },
                { value: 'cynov', label: formatMessage({ id: 'bdc.provider.cynov' }), isDisabled: !selectedTarget?.erpReady }
              ]}
              selectedValues={[{ value: selectedProvider, label: formatMessage({ id: `bdc.provider.${selectedProvider}` }) }]}
              onChange={values => setSelectedProvider(values[0].value as 'cynov' | 'internal')}
              placeholder={formatMessage({ id: 'bdc.provider.select' })} />
          </div>
          {selectedProvider === 'internal' && !internalReady &&
            <p className={styles.providerNotice} role="alert">{formatMessage({ id: 'bdc.config.internalUnavailable' })}</p>}
          <div className={styles.providerActions}>
            <Button type={canConfirmProvider ? BUTTON_MAIN_TYPE.SECONDARY : BUTTON_MAIN_TYPE.DISABLED}
              disabled={!canConfirmProvider || isSubmitting}
              onClick={() => { setIsProviderModalOpen(false); sendBdcDemand(false, selectedProvider); }}>
              {formatMessage({ id: 'wall.posts.confidentiality.confirm' })}
            </Button>
            <Button type={BUTTON_MAIN_TYPE.PRIMARY_INVERTED} onClick={() => setIsProviderModalOpen(false)}>
              {formatMessage({ id: 'bdc.payment.cancel' })}
            </Button>
          </div>
        </div>
      </FlexibleModalContainer>}
      
      <FlexibleModalContainer
        className={`${styles.modalContainer}`}
        animationClass={styles.modalAnimation}
        fullOnMobile={false}
        closeModal={closeAndReturn}
        isModalOpen={isModalOpen}
      >
        <div>
          <div className={styles.modalText}>
            <DynamicFormattedMessage
              tag="span"
              className={coreStyle.mxAuto}
              id={modalMessage}
            />
          </div>
          <div className={styles.buttonContainer}>
            {!isWarning && !isLimit && isOK && (
              <DynamicFormattedMessage
                onClick={() => onClickOk()}
                tag={Button}
                className={coreStyle.mxAuto}
                id="label.yes.modal"
              />
            )}
            {isWarning && (
              <DynamicFormattedMessage
                onClick={() => onClickOkWarning()}
                tag={Button}
                className={coreStyle.mxAuto}
                id="label.warning.modal"
              />
            )}
            <DynamicFormattedMessage
              onClick={closeAndReturn}
              tag={Button}
              className={coreStyle.mxAuto}
              id="label.no.modal"
            />
          </div>
        </div>
      </FlexibleModalContainer>
    </div>

  )
}

export default BdcWinsDemand;
